import { Theme } from "@mui/material/styles";

import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";
import { WORK_HISTORY_ZINDEX } from "constants/styles";

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            background: theme.palette.common.white,
            borderRadius: 10,
            boxShadow: `0 3px 10px 1px ${theme.palette.others.darkestColor}44`,
            zIndex: WORK_HISTORY_ZINDEX,
            position: "absolute",
            maxWidth: 500,
        },
        closeButton: {
            position: "absolute",
            right: 10,
            padding: theme.spacing(0.5),
        },
        closeIcon: {
            fontSize: 16,
            color: theme.palette.common.white,
        },
        header: {
            background: theme.palette.primary.main,
            color: theme.palette.common.white,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: theme.spacing(1.5, 2),
            position: "relative",
            borderTopLeftRadius: 5,
            borderTopRightRadius: 5,
        },
        peopleHeader: {
            background: theme.palette.primary.main,
            color: theme.palette.common.white,
            display: "flex",
            flexDirection: "column",
            position: "relative",
            borderTopLeftRadius: 5,
            borderTopRightRadius: 5,
        },
        subHeader: {
            backgroundColor: theme.palette.background.blue,
            padding: theme.spacing(1, 2),
            marginBottom: theme.spacing(1),
        },
        headerSubtitle: {
            background: theme.palette.primary.main,
            color: theme.palette.common.white,
            display: "flex",
            justifyItems: "center",
            alignItems: "center",
            fontSize: 14,
            padding: theme.spacing(0, 1, 1.5, 1),
        },
        headerName: {
            textTransform: "capitalize",
            fontWeight: 600,
            letterSpacing: 1.6,
            lineHeight: 1.2,
        },
        headerRole: {
            fontWeight: 700,
            marginRight: 5,
            textTransform: "uppercase",
        },
        headerDivider: {
            width: "3px",
            backgroundColor: theme.palette.neutrals.dark,
            margin: theme.spacing(0.75, 1),
        },
        restoreIcon: {
            fontSize: 24,
            marginRight: 10,
        },
        restoreIconInvisible: {
            fontSize: 24,
            marginRight: 10,
            color: theme.palette.primary.main,
        },
        backButton: {
            display: "flex",
            alignItems: "center",
            position: "absolute",
            right: 0,
            color: theme.palette.common.white,
            padding: 0,
            "&:hover": {
                backgroundColor: "transparent",
            },
            "& .MuiSvgIcon-root": {
                fontSize: 16,
                marginRight: theme.spacing(0.3),
            },
        },
        headerInfoNA: {
            fontSize: 20,
            marginBottom: theme.spacing(1),
        },
        bodyInfoNA: {
            fontSize: 14,
            padding: theme.spacing(1),
        },
        feedbackButton: {
            background: "#DF5729",
            fontWeight: 700,
            display: "inline-block",
            color: theme.palette.common.white,
            padding: theme.spacing(0.5, 1),
            borderRadius: theme.spacing(0.6, 0.6, 0, 0),
        },
        paceButton: {
            borderWidth: "2px",
            borderColor: theme.palette.primary.main,
            color: theme.palette.primary.main,
        },
    })
);
